import { SiriusBaseComponent } from 'sirius-framework';
import { Component, Input } from '@angular/core';
import { CommonService } from '../../service/shared.service';
import { ProcessAction, ProcessStateList, ProcessDetailActionRequest } from '../../models/process.model';

const PROCESS_ACTION_KEYS = {
    time: 'yediEminProcessActionTime',
    status: 'yediEminProcessActionStatus',
    processStatus10: 'yediEminProcessActionProcessStatus10',
    processStatus20: 'yediEminProcessActionProcessStatus20',
    processStatus60: 'yediEminProcessActionProcessStatus60',
    processStatus30: 'yediEminProcessActionProcessStatus30',
    processStatus50: 'yediEminProcessActionProcessStatus50',
    processStatus71: 'yediEminProcessActionProcessStatus71',
    noResultMessage: 'yediEminProcessActionNoResultMessage',
};

/** Eski DB kayıtlarıyla uyumluluk (yalnızca yeni anahtar dolu değilse kullanılır). */
const PROCESS_ACTION_LEGACY_KEYS = {
    time: 'processAction_Time',
    status: 'processAction_Status',
    processStatus10: 'processAction_ProcessStatus10',
    processStatus20: 'processAction_ProcessStatus20',
    processStatus60: 'processAction_ProcessStatus60',
    processStatus30: 'processAction_ProcessStatus30',
    processStatus50: 'processAction_ProcessStatus50',
    processStatus71: 'processAction_ProcessStatus71',
};

@Component({
    selector: 'process-action',
    templateUrl: './process-action.component.html',
    styleUrls: ['./process-action.component.css']
})
export class ProcessActionComponent extends SiriusBaseComponent<any> {
    @Input('ProcessRef') processRef: string;
    @Input('IsLive') isLive: boolean;
    processActionResult: ProcessAction = null;
    noResult: boolean = false;
    processActionResultList: ProcessStateList[] = [];
    mainSteps: boolean[] = [false, false, false, false, false, false];
    processAction_Time = 'Zaman';
    processAction_Status = 'Durum';
    processAction_ProcessStatus10 = 'Süreç bildirimi';
    processAction_ProcessStatus20 = 'Onay';
    processAction_ProcessStatus60 = 'Banka işlemi';
    processAction_ProcessStatus30 = 'Ödeme / teminat';
    processAction_ProcessStatus50 = 'Tamamlama';
    processAction_ProcessStatus71 = 'Teslim / protokol';
    noResultMessage = 'Bilgi Getirilemedi';
    constructor(private commonService: CommonService) {
        super();
    }
    OnInit() {
        this.loadProcessActionResourceStrings();
        if (this.commonService.selectedProcessAction != null) {
            if (this.commonService.selectedProcessAction.processRef == this.processRef) {
                this.processActionResult = this.commonService.selectedProcessAction.data as ProcessAction;
                this.processActionResultList = this.processActionResult.ProcessStateList;
                if (this.processActionResultList != null && this.processActionResultList.length > 0) {
                    this.mainSteps[0] = this.processActionResultList.some(x => x.ProcessStatus == "10");
                    this.mainSteps[1] = this.processActionResultList.some(x => x.ProcessStatus == "20");
                    this.mainSteps[2] = this.processActionResultList.some(x => x.ProcessStatus == "60");
                    this.mainSteps[3] = this.processActionResultList.some(x => x.ProcessStatus == "40");
                    this.mainSteps[4] = this.processActionResultList.some(x => x.ProcessStatus == "50");
                    this.mainSteps[5] = this.processActionResultList.some(x => x.ProcessStatus == "71");
                }
            }
            else {
                this.commonService.selectedProcessAction = null;
                this.callProcessActionService();
            }
        }
        else {
            this.callProcessActionService();
        }           
    }
    private loadProcessActionResourceStrings(): void {
        const r = (nk: string, lk: string, fb: string) =>
          this.commonService.getStringResourcePreferNewKey(nk, lk, fb);
        this.processAction_Time = r(PROCESS_ACTION_KEYS.time, PROCESS_ACTION_LEGACY_KEYS.time, this.processAction_Time);
        this.processAction_Status = r(PROCESS_ACTION_KEYS.status, PROCESS_ACTION_LEGACY_KEYS.status, this.processAction_Status);
        this.processAction_ProcessStatus10 = r(PROCESS_ACTION_KEYS.processStatus10, PROCESS_ACTION_LEGACY_KEYS.processStatus10, this.processAction_ProcessStatus10);
        this.processAction_ProcessStatus20 = r(PROCESS_ACTION_KEYS.processStatus20, PROCESS_ACTION_LEGACY_KEYS.processStatus20, this.processAction_ProcessStatus20);
        this.processAction_ProcessStatus60 = r(PROCESS_ACTION_KEYS.processStatus60, PROCESS_ACTION_LEGACY_KEYS.processStatus60, this.processAction_ProcessStatus60);
        this.processAction_ProcessStatus30 = r(PROCESS_ACTION_KEYS.processStatus30, PROCESS_ACTION_LEGACY_KEYS.processStatus30, this.processAction_ProcessStatus30);
        this.processAction_ProcessStatus50 = r(PROCESS_ACTION_KEYS.processStatus50, PROCESS_ACTION_LEGACY_KEYS.processStatus50, this.processAction_ProcessStatus50);
        this.processAction_ProcessStatus71 = r(PROCESS_ACTION_KEYS.processStatus71, PROCESS_ACTION_LEGACY_KEYS.processStatus71, this.processAction_ProcessStatus71);
        this.noResultMessage = this.commonService.getStringResource(PROCESS_ACTION_KEYS.noResultMessage, this.noResultMessage);
    }
    callProcessActionService() {
        var processDetailActionRequest: ProcessDetailActionRequest = {
            ProcessRef: this.processRef,
            IsLive: this.isLive
        }
        var promise = this.commonService.GetProcessAction(this.dataService, processDetailActionRequest);
        promise.then((result) => {
            if (result != null) {
                this.processActionResult = result as ProcessAction;
                if (!this.processActionResult.IsThereError) {
                    this.processActionResultList = this.processActionResult.ProcessStateList;
                    this.commonService.selectedProcessAction = { processRef: this.processRef, data: this.processActionResult };
                    if (this.processActionResultList != null && this.processActionResultList.length > 0) {
                        this.mainSteps[0] = this.processActionResultList.some(x => x.ProcessStatus == "10");
                        this.mainSteps[1] = this.processActionResultList.some(x => x.ProcessStatus == "20");
                        this.mainSteps[2] = this.processActionResultList.some(x => x.ProcessStatus == "60");
                        this.mainSteps[3] = this.processActionResultList.some(x => x.ProcessStatus == "40");
                        this.mainSteps[4] = this.processActionResultList.some(x => x.ProcessStatus == "50");
                        this.mainSteps[5] = this.processActionResultList.some(x => x.ProcessStatus == "71");
                    }
                    this.noResult = false;
                }
                else {
                    this.processActionResult = null;
                    this.noResult = true;
                }
            }
        });
    }
    GetDateTimeText(date: string, time: string) {
        let dateText = "";
        let timeText = "";
        if (date != null && date.length == 8)
            dateText = date.substr(6, 2) + '.' + date.substr(4, 2) + '.' + date.substr(0, 4);
        if (time != null && time.length == 6)
            timeText = time.substr(0, 2) + ":" + time.substr(2, 2);
        return dateText + " " + timeText;
    }
}
